<script setup>

</script>

<template>
  <div class="d-flex justify-content-center py-3">
    <div class="spinner-grow" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</template>

<style scoped>

</style>
